import {purchaseEsim, purchaseEsimList,purchaseEsimDownload,purchaseEsimPreview, sendToEmail} from 'api/esimPurchase';
import Cookies from 'js-cookie';

const esimPurchase = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        //test
        purchaseEsim({commit}, keyword) {
            return new Promise((resolve, reject) => {
                purchaseEsim(keyword).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        purchaseEsimList({commit}, imsi) {
            return new Promise((resolve, reject) => {
                purchaseEsimList(imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        purchaseEsimDownload({commit}, imsi) {
            return new Promise((resolve, reject) => {
                purchaseEsimDownload(imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        purchaseEsimPreview({commit}, imsi) {
            return new Promise((resolve, reject) => {
                purchaseEsimPreview(imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        sendToEmail({commit}, imsi) {
            return new Promise((resolve, reject) => {
                sendToEmail(imsi).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default esimPurchase;



// WEBPACK FOOTER //
// ./src/store/modules/esimPurchase.js